/**
 * Subscribe to the rect of a DOM element.
 * @beta
 *
 * @deprecated Use `useElementSize` instead
 */
export function useElementRect(_element?: never): never {
  throw new Error('`useElementRect` was removed in @sanity/ui v4. Use `useElementSize` instead.')
}
